<template>
  <div class="live-page">
    <div id="video-container" style="margin: 0px auto;"></div>
  </div>
</template>

<script src="//imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.2.js"></script>
<script>
export default {
  name: "livePage",
  data() {
    return {
      rtmp: null,
      flv: null,
      m3u8: null,
      mp4: null,
      live: null,
      coverpic: null,
      width: null,
      height: null,
      volume: null,
      flash: null,
      x5_player: null,
      h5_flv: null,
      autoplay: null,
      flashUrl: null,
      params: null,
      log: null
    };
  },
  methods: {
    getParams(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    getPathParams() {
      var path = location.pathname.split("/");
      if (path[1] == "vod-player") {
        return {
          path: location.origin + path.slice(0, 4).join("/"),
          appid: path[2],
          fileid: path[3]
        };
      } else {
        return null;
      }
    },
    initLive() {
      var _this = this;
      this.rtmp = this.getParams("rtmp");
      this.flv = this.getParams("flv");
      this.m3u8 = this.getParams("m3u8");
      this.mp4 = this.getParams("mp4");
      this.live = this.getParams("live") == "true" ? true : false;
      this.coverpic = this.getParams("coverpic");
      this.width = this.getParams("width");
      this.height = this.getParams("height");
      this.volume = this.getParams("volume");
      this.flash = this.getParams("flash") == "true" ? true : false;
      this.x5_player = this.getParams("x5_player") == "false" ? false : true;
      this.h5_flv = this.getParams("h5_flv") == "true" ? true : false;
      this.autoplay = this.getParams("autoplay") == "true" ? true : false;
      var params = this.getPathParams();
      if (params) {
        this.flashUrl = params.path + "/player/release/QCPlayer.swf";
      } else {
        this.flashUrl =
          "//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf";
      }
      // this.flashUrl = (function() {
      //   var params = this.getPathParams();
      //   if (params) {
      //     return params.path + "/player/release/QCPlayer.swf";
      //   }
      //   return "//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf";
      // })();
      this.log = this.getParams("log");
      var options = {
        //原来测试例子
        // m3u8: 'https://1256993030.vod2.myqcloud.com/d520582dvodtransgzp1256993030/cc9f922c5285890781386012275/v.f220.m3u8' ,
        // mp4: 'https://1256993030.vod2.myqcloud.com/d520582dvodtransgzp1256993030/7732bd367447398157015849771/v.f30.mp4',

        //直播本项目固定配置
        // rtmp: "rtmp://pull.sysbiz.cn/live/systarsoft",
        // m3u8: "http://pull.sysbiz.cn/live/systarsoft.m3u8",
        m3u8: "http://readpull.systarsoft.com/live/kjjlive.m3u8",
        // flv: "http://pull.sysbiz.cn/live/systarsoft.flv",
        autoplay: true, //固定自动播放
        live: this.live,
        width: this.width || "480",
        height: this.height || "320",
        volume: this.volume || 0.5,
        flash: this.flash,
        flashUrl: this.flashUrl,
        x5_player: this.x5_player,
        h5_flv: this.h5_flv,
        wording: {
          2032: "请求视频失败，请检查网络",
          2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
        },
        listener: function(msg) {
          if (msg.type == "load") {
            var _div = document.createElement("div");
            _div.className = "marker";
            _div.innerText = "标题";
            document.querySelector(".vcp-player").appendChild(_div);
          }
        }
      };
      window.tcplayer = new TcPlayer("video-container", options);
    }
  },
  mounted() {
    this.initLive();
  }
};
</script>

<style lang="stylus" scoped>
.vcp-error-tips
  color: #fff;
a
  color: #fff;
.vcp-player .marker
    position: absolute;
    font-size: 20px;
    color: rgba(255, 255, 255, .5);
    top: 0;
    right: 5px;
.live-page
  #video-container
    font-size 18px
    font-weight bold
</style>
